import { AxiosResponse } from 'axios';
import apiInterceptor from '../utils/axios';
import { GenericResponse } from '../types/Response/GenericResponse';

const SERV_BACK: string = process.env.REACT_APP_API_ESPOL_ADS || '';
const APIMASIVO = 'api/Catalog/correomasivo/';

export default class CorreoMasivoService {

    static async SendMailDiario(usuario: string): Promise<GenericResponse> {
        try {
            const response: AxiosResponse<any> = await apiInterceptor.get(`${SERV_BACK}${APIMASIVO}emailApersona/${usuario}`,
                {
                    headers: {
                        "Content-type": "application/json",
                    },
                }
            );
            if (response.status === 200) {
                console.log('Respuesta exitosa');
                return {
                  status: response.status,
                  message: 'Operación completada con éxito',
                };
              } else {
                console.error('Respuesta no exitosa:', response.status);
                return {
                  status: response.status,
                  message: `Error: Código de estado ${response.status}`,
                };
              }
        } catch (error) {
            console.error('Error al realizar la solicitud:', error);

            return {
                status: 500,
                message: 'Error al realizar la solicitud',
            };
        }
    }
}